<!--
TEXTAREA
------------------------------------
사용 예 )
------------------------------------
rows 속성 설정 ( 숫자형태로 받기때문에 v-bind로 할당해줘야 오류안남)
    <app-input-textarea
        :textarea-rows="3"
    ></app-input-textarea>

-->
<template>
    <div class="textarea-wrap" :class="classObject" :style="[defaultCssVariables, cssVariables]">
        <textarea
            type="text"
            class="uk-textarea"

            :id="id"
            :name="name"
            :placeholder="placeholder"
            :class=" inputSizeClass"
            :value="value"
            @input="updateValue"
            @focus="focus"
            @focusout="focusout"

            :rows="textareaRows"
            :readonly="readonly"
            :disabled="disabled"
        ></textarea>

        <div class="custom-placeholder" v-if="visibleCustomPlaceholder">
            <slot name="customPlaceholder"></slot>
        </div>

    </div>
</template>

<script>
import InputBase from './base.vue';

export default {
    extends: InputBase,
}
</script>

<style lang="scss" scoped>
    .textarea-wrap {
        position: relative;
        transform: translateY(0px); // 왜인지 모르겠지만, 이 값 설정안되면 z-index -1 적용안되는거같음.
        background-color: #ffffff;

        textarea {
            background-color: transparent;
        }
    }

    .custom-placeholder {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;

    }
</style>